import { GET_TIME_OFF_ENTRIES, GET_TIME_OFF_ENTRIES_AS_DELEGATE } from './query'

export const fetchTimeOffEntriesInDateRange = async ({
  client,
  startISO,
  endISO,
  selectedDelegateId,
}) => {
  const { data } = await client.query({
    query: selectedDelegateId ? GET_TIME_OFF_ENTRIES_AS_DELEGATE : GET_TIME_OFF_ENTRIES,
    variables: {
      startISO,
      endISO,
      delegateId: selectedDelegateId,
    },
  })
  return selectedDelegateId ? data.timeOffEntries_getAll_asDelegate : data.timeOffEntries_getAll
}
